import { Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from '../app.component';
import { DataBaseService } from '../provider.service';
import { MASKS } from 'ng-brazil';

@Component({
  selector: 'app-fornecedores',
  templateUrl: './fornecedores.component.html',
  styleUrls: ['./fornecedores.component.css']
})
export class FornecedoresComponent implements OnInit {
  @ViewChild('pdfViewerFornecedores') pdfViewerOnDemand;
  public MASKS = MASKS;
  dataHoje:any = "";
  fornecedores:any = [];
  fornecedorEditar:any = "";
  fornecedorSearch:any = "";
  agenciaEditar:any = "";
  contaCorrenteEditar:any = "";
  razaoSocial:any = "";
  nomeFantasia:any = "";
  cnpj:any = "";
  endereco:any = "";
  numero:any = "";
  bairro:any = "";
  cidade:any = "";
  estado:any = "";
  telefone:any = "";
  celular:any = "";
  responsavel:any = "";
  email:any = "";
  banco:any = "";
  agencia:any = "";
  agenciaDigito:any = "";
  contaCorrente:any = "";
  contaCorrenteDigito:any = "";
  tipoPix:any = "";
  pix:any = "";
  todosFornecedores:any = "";
  vigencia:any = "";
  vigenciaFim:any = "";
  selectedFilesFornecedorEditar:any = "";
  filesFornecedorEditar:any = [];
  docsFornecedorEditar:any = [];
  pdfsFornecedorEditar:any = [];
  imagesFornecedorEditar:any = [];
  imagemSelecionada:any = "";
  indexImage:number = 0;
  constructor(public db:DataBaseService, public app:AppComponent){}

  ngOnInit(){
    this.dataHoje = new Date(Date.now() - 10800000).toISOString().split('T')[0];
    this.getFornecedor();
  }

  getFornecedor(){
    this.db.getAllFornecedores().subscribe((data:any) => {
      this.fornecedores = data;
      this.todosFornecedores = data;
    })
  }

  buscarFornecedor(fornecedor){
    this.todosFornecedores = this.fornecedores.filter(item => {
      return item.razaoSocial.toLowerCase().indexOf(fornecedor.toLowerCase()) > -1;
    });
  }
  
  openModalEditarFornecedor(fornecedor:any){
    this.fornecedorEditar = fornecedor;
    this.agenciaEditar = fornecedor?.agencia;
    this.contaCorrenteEditar = fornecedor?.contaCorrente;
    this.pdfsFornecedorEditar = [];
    this.imagesFornecedorEditar = [];
    if(fornecedor?.documentos?.length > 0){
      fornecedor.documentos.forEach((item) => {
      let ext = item.url.split('.').pop();
        if(ext == 'pdf' || ext == 'PDF'){
          this.pdfsFornecedorEditar.push(item);
        }else{
          this.imagesFornecedorEditar.push(item);
        }
      })
    }
    let modal = document.getElementById('modalEditarFornecedores');
    modal.style.display = "block"
  }

  closeModalEditarFornecedor(){
    this.fornecedorEditar = "";
    this.agenciaEditar = null;
    this.contaCorrenteEditar = null;
    let modal = document.getElementById('modalEditarFornecedores');
    modal.style.display = "none"
  }
  
  salvarFornecedor(){
    let dados = {
      razaoSocial: this.razaoSocial,
      nomeFantasia: this.nomeFantasia,
      cnpj: this.cnpj,
      endereco: this.endereco,
      numero: this.numero,
      bairro: this.bairro,
      cidade: this.cidade,
      estado: this.estado,
      telefone: this.telefone,
      celular: this.celular,
      responsavel: this.responsavel,
      email: this.email,
      banco: this.banco,
      agencia: this.agencia,
      agenciaDigito: this.agenciaDigito,
      contaCorrente: this.contaCorrente,
      contaCorrenteDigito: this.contaCorrenteDigito,
      tipoPix:this.tipoPix,
      pix: this.pix,
      vigencia: this.vigencia,
      vigenciaFim: this.vigenciaFim
    };
    this.db.cadastroFornecedor(dados).subscribe(res => {
      console.log(res);
      this.app.openAlert("Fornecedor cadastrado com sucesso!");
      this.closeModalNovoFornecedor();
      this.getFornecedor();
    }, err => {
      console.log(err);
      this.app.openAlert("Erro ao cadastrar Fornecedor!");
    })
  }

  editarFornecedor(){
    let dados = {
      razaoSocial: this.fornecedorEditar.razaoSocial,
      nomeFantasia: this.fornecedorEditar.nomeFantasia,
      cnpj: this.fornecedorEditar.cnpj,
      endereco: this.fornecedorEditar.endereco,
      numero: this.fornecedorEditar.numero,
      bairro: this.fornecedorEditar.bairro,
      cidade: this.fornecedorEditar.cidade,
      estado: this.fornecedorEditar.estado,
      telefone: this.fornecedorEditar.telefone,
      celular: this.fornecedorEditar.celular,
      responsavel: this.fornecedorEditar.responsavel,
      email: this.fornecedorEditar.email,
      banco: this.fornecedorEditar.banco,
      agencia: this.agenciaEditar,
      contaCorrente: this.contaCorrenteEditar,
      pix: this.fornecedorEditar.pix,
      agenciaDigito: this.fornecedorEditar.agenciaDigito,
      contaCorrenteDigito: this.fornecedorEditar.contaCorrenteDigito,
      tipoPix:this.fornecedorEditar.tipoPix,
      vigencia:this.fornecedorEditar.vigencia,
      vigenciaFim: this.fornecedorEditar.vigenciaFIm
    };
    this.db.editarFornecedor(this.fornecedorEditar._id,dados).subscribe(res => {
      console.log(res);
      this.app.openAlert("Fornecedor editado com sucesso!");
      this.closeModalEditarFornecedor();
      this.getFornecedor();
    }, err => {
      console.log(err);
      this.app.openAlert("Erro ao cadastrar Fornecedor!");
    })
  }

  openModalNovoFornecedor(){
    let modal = document.getElementById('modalNovoFornecedores');
    modal.style.display = "block"
  }

  closeModalNovoFornecedor(){
    this.razaoSocial = "";
    this.nomeFantasia = "";
    this.cnpj = "";
    this.endereco = "";
    this.numero = "";
    this.bairro = "";
    this.cidade = "";
    this.estado = "";
    this.telefone = "";
    this.celular = "";
    this.responsavel = "";
    this.email = "";
    this.banco = "";
    this.agencia = null;
    this.agenciaDigito = "";
    this.contaCorrente = null;
    this.contaCorrenteDigito = "";
    this.tipoPix = "";
    this.pix = "";
    this.vigencia = "";
    this.vigenciaFim = "";
    let modal = document.getElementById('modalNovoFornecedores');
    modal.style.display = "none";
  }

  excluirFornecedor(fornecedor){
    if(window.confirm("Deseja realmente excluir esse Forncedor?")){
      let jsonDate = new Date().toJSON();
      let hora = new Date(jsonDate).toLocaleTimeString();
      this.db.deleteFornecedor(fornecedor._id).subscribe(res => {
        console.log(res);
        this.app.openAlert("Fornecedor Excluido com Sucesso!");
        this.getFornecedor();
      },err => {
      console.log(err)
    })
    }
  }

  
onChangeClickFornecedorEditar(event){
  let arrayTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
  this.selectedFilesFornecedorEditar = <FileList>event.srcElement.files;
  for(let i=0; i<this.selectedFilesFornecedorEditar.length; i++){
      if(!arrayTypes.includes(this.selectedFilesFornecedorEditar[i].type)){
      this.app.openAlert("Tipo de Arquivo Não Suportado!\nEscolha uma imagem com a extensão .JPG, .JPEG, .PNG ou PDF")
      this.selectedFilesFornecedorEditar = "";
    }} 
    this.filesFornecedorEditar = [];
    for(let i=0; i<this.selectedFilesFornecedorEditar.length; i++){
      this.filesFornecedorEditar.push(this.selectedFilesFornecedorEditar[i].name);
    }
}

onChangeFornecedorEditar(event){
  let arrayTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
  this.selectedFilesFornecedorEditar = <FileList>event;
  for(let i=0; i<this.selectedFilesFornecedorEditar.length; i++){
      if(!arrayTypes.includes(this.selectedFilesFornecedorEditar[i].type)){
      this.app.openAlert("Tipo de Arquivo Não Suportado!\nEscolha uma imagem com a extensão .JPG, .JPEG, .PNG ou PDF")
      this.selectedFilesFornecedorEditar = "";
    }} 
    this.filesFornecedorEditar = [];
    for(let i=0; i<this.selectedFilesFornecedorEditar.length; i++){
      this.filesFornecedorEditar.push(this.selectedFilesFornecedorEditar[i].name);
    }
}

anexarDocFornecedor(){
  if(this.filesFornecedorEditar.length > 0){
    const imagedata = new FormData();
    for(let i=0; i<this.selectedFilesFornecedorEditar.length; i++){
      imagedata.append('files[]', this.selectedFilesFornecedorEditar[i], this.selectedFilesFornecedorEditar[i].name);
      imagedata.append('id',this.fornecedorEditar._id);
    };
     this.db.enviarDocFornecedor(imagedata).subscribe((res) => {
         console.log(res);
         this.getDocsFornecedorEditar();
       },(error) => {
         console.log(error);
         this.getDocsFornecedorEditar();
       });
    }
  }

getDocsFornecedorEditar(){
  this.docsFornecedorEditar = [];
  this.filesFornecedorEditar = [];
  this.db.getFornecedorById(this.fornecedorEditar._id).subscribe((result:any) => {
    this.docsFornecedorEditar = result.documentos;
    this.pdfsFornecedorEditar = [];
    this.imagesFornecedorEditar = [];
    this.selectedFilesFornecedorEditar = "";
    this.filesFornecedorEditar = [];
    if(this.docsFornecedorEditar && this.docsFornecedorEditar.length > 0){
      this.pdfsFornecedorEditar = [];
      this.imagesFornecedorEditar = [];
      this.docsFornecedorEditar.forEach((item) => {
      let ext = item.url.split('.').pop();
        if(ext == 'pdf' || ext == 'PDF'){
          this.pdfsFornecedorEditar.push(item);
        }else{
          this.imagesFornecedorEditar.push(item);
        }
      })
    }
  })
}


openModalPdfViewer(url){
  this.pdfViewerOnDemand.pdfSrc = url;
  this.pdfViewerOnDemand.refresh();
}

openModalLightBox(url, i){
  this.indexImage = i;
  this.imagemSelecionada = url;
  let modal = document.getElementById('myModalFornecedores')
  modal.style.display = "block";
}

nextImg(){
  let i = this.indexImage;
  if((this.imagesFornecedorEditar.length - 1) == i){
    this.imagemSelecionada = this.imagesFornecedorEditar[0].url;
    this.indexImage = 0;
  }else{
    i++
    this.imagemSelecionada = this.imagesFornecedorEditar[i].url;
    this.indexImage++
  }
}

prevImg(){
  let i = this.indexImage
  if(i == 0){
    this.imagemSelecionada = this.imagesFornecedorEditar[this.imagesFornecedorEditar.length - 1].url;
    this.indexImage = this.imagesFornecedorEditar.length - 1;
  }else{
    i--
    this.imagemSelecionada = this.imagesFornecedorEditar[i].url;
    this.indexImage--
  }
}

closeModal(){
  let modal = document.getElementById('myModalFornecedores')
  modal.style.display = "none";
}

}
